import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createBankingDetailsStart,
  deleteBankingDetailsStart,
  deleteSABannersStart,
  getAllSABannersStart,
  getBankingDetailsStart,
  updateBankingDetailsStart,
  updateBankingDetailsStatusOptimistic,
  updateBankingDetailsStatusStart,
  updateSABannerStart,
  uploadSABannerStart,
} from "../../../../store/redux-slices/superAdminSettings";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import useCheckPermission from "../../../../utils/checkPermission";

const useBankingDetails = (bankType) => {
  const { loading, bankingDetails } = useSelector(
    (state) => state.superAdminSettings
  );
  const isInitialRender = useDidMountEffect();
  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { isHidden } = useCheckPermission();
  const totalPages = bankingDetails?.pagination?.totalPages;
  const totalCount = bankingDetails?.pagination?.total;

  useEffect(() => {
    setPage(1);
    dispatch(
      getBankingDetailsStart({
        limit: limit,
        pageNo: page,
        bankType
      })
    );
  }, [limit]);

  useEffect(() => {
    !isInitialRender &&
      dispatch(
        getBankingDetailsStart({
          limit: limit,
          pageNo: page,
          bankType
        })
      );
  }, [page]);

  const handleCreateEdit = (type, data) => {
    setType(type);
    setData(data);
    setShow(true);
  };

  const handleToggleStatus = (bankDetailsId, newStatus) => {
    const currentBank = bankingDetails?.data?.find(
      (bank) => bank.bank_details_id === bankDetailsId
    );

    if (currentBank) {
      // Dispatch optimistic update first
      dispatch(
        updateBankingDetailsStatusOptimistic({
          bankDetailsId,
          newStatus,
        })
      );

      const updateData = {
        bankDetailsId,
        status: newStatus,
      };

      dispatch(
        updateBankingDetailsStatusStart({
          data: updateData,
          previousStatus: currentBank.status,
          onSuccess: () => {
            console.log("Bank details status updated successfully");
          },
          onError: () => {
            // Revert the optimistic update on error
            dispatch(
              updateBankingDetailsStatusOptimistic({
                bankDetailsId,
                newStatus: currentBank.status, // Revert to original status
              })
            );
          },
        })
      );
    } else {
      console.error("Bank details not found with ID:", bankDetailsId);
    }
  };

  const handleDelete = (bankDetailsId) => {
    dispatch(
      deleteBankingDetailsStart({
        bankDetailsId,
        onSuccess: () => {
          dispatch(
            getBankingDetailsStart({
              limit: limit,
              pageNo: page,
              bankType
            })
          );
        },
      })
    );
  };

  const createUpdate = (data) => {
    const actionCreator =
      type === "Create"
        ? createBankingDetailsStart({
          ...data,
          onSuccess: () => {
            setShow(false);

            dispatch(
              getBankingDetailsStart({
                limit: limit,
                pageNo: page,
                bankType
              })
            );
          },
        })
        : updateBankingDetailsStart({
          ...data,
          onSuccess: () => {
            setShow(false);

            dispatch(
              getBankingDetailsStart({
                limit: limit,
                pageNo: page,
                bankType
              })
            );
          },
        });

    dispatch(actionCreator);
  };

  return {
    loading,
    bankingDetails: bankingDetails?.data || [],
    handleCreateEdit,
    type,
    data,
    setShow,
    show,
    createUpdate,
    dispatch,
    isHidden,
    handleDelete,
    page,
    limit,
    setPage,
    setLimit,
    totalPages,
    handleToggleStatus,
    totalCount
  };
};

export default useBankingDetails;
